import OSS from 'ali-oss'

import { getSts } from '@/api/global'

import { getUUID } from './tool'

class UploadClient {
  prefix: string

  constructor() {
    this.prefix = `${import.meta.env.VITE_APP_ENV}/vip/classroom/courseware`
  }

  public getOSSClient() {
    return new Promise((resolve) => {
      const ossSignFormData = new FormData()
      ossSignFormData.append('bucket', 'vip-star')
      ossSignFormData.append('prefix', import.meta.env.VITE_APP_ENV)
      ossSignFormData.append('source', 'webapp') // 不能为空
      getSts(ossSignFormData).then((res) => {
        const { bucketName, endpoint, accessKeyId, accessKeySecret, securityToken, expiration, realmName } = res.data
        // 构造临时凭证
        const OSSClientData = {
          bucket: bucketName, // bucket名称
          region: endpoint.split('.')[0], // 地域
          accessKeyId: accessKeyId,
          accessKeySecret: accessKeySecret,
          stsToken: securityToken,
          expiration: expiration, // 有效期
          // 刷新临时访问凭证。
          refreshSTSToken: async () => {
            const res = await getSts(ossSignFormData)
            const { accessKeyId, accessKeySecret, stsToken } = res.data.data
            return {
              accessKeyId,
              accessKeySecret,
              stsToken
            }
          }
        }
        // 实例化
        const OSSClient = new OSS(OSSClientData)
        resolve({ OSSClient, realmName })
      })
    })
  }

  public async fileUpload(files: File[]) {
    const promises: object[] = []
    return await new Promise((resolve, reject) => {
      // 获取实例
      this.getOSSClient().then(async ({ OSSClient, realmName }: any) => {
        for (let i = 0; i < files.length; i++) {
          const filename = files[i].name.split('.')
          const suffix = filename[filename.length - 1]
          const uuid = getUUID()
          const filePath = `${this.prefix}/${uuid}.${suffix}`
          // 上传
          await OSSClient.multipartUpload(filePath, files[i], {})
            .then((res: { name: any }) => {
              const { name } = res
              const picUrl = `${realmName}/${name}`
              promises[i] = {
                picId: uuid,
                picUrl,
                lines: [],
                type: 1,
                courseType: 1,
                width: 0,
                heigit: 0,
                json: null,
                small_url: picUrl
              }
            })
            .catch((err: any) => {
              console.log('err :>> ', err)
            })
        }
        resolve(promises)
      })
    })
  }
}

export default new UploadClient()
